export default __webpack_public_path__ + "static/media/david_townsend.6652e925.png";